module.exports = __webpack_public_path__ + "components/page-footer/static/tide-forecast__logo--white-7a02eb264c4769eec74d703772b75cac.png";